import { defineMessages } from 'react-intl';

export const messages: {
	clearIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inputPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inputInstructions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	filterToggleLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	clearIconLabel: {
		id: 'input_clear_icon_label',
		defaultMessage: 'Clear search',
		description: 'Label text for clear search button',
	},
	inputPlaceholder: {
		id: 'input_placeholder',
		defaultMessage: 'Search',
		description:
			'Placeholder text in primary search input. Also used as the input accessible name, so keep it to a single word that voice-control users can say.',
	},
	inputInstructions: {
		id: 'input_aria_label',
		defaultMessage: 'Press enter to navigate to advanced search with your text query',
		description:
			'Instruction for the primary search input, announced via aria-describedby, directs users to advanced search',
	},
	filterToggleLabel: {
		id: 'search-page.common.quick-find.textfield.filterToggleLabel',
		defaultMessage: 'Filters',
		description: 'Accessible label for the button that expands or collapses Quick Find filters',
	},
});
